// utils/TransitionManager.ts
export class TransitionManager {
    static enter(element, transitionName, speed = "medium") {
        const duration = this.speedMap[speed] || 400;
        const className = this.getInputClass(transitionName);
        if (!className)
            return;
        // Apply initial state
        element.classList.add(className);
        // Force reflow
        void element.offsetWidth;
        requestAnimationFrame(() => {
            element.style.transition =
                `transform ${duration}ms ease, opacity ${duration}ms ease`;
            // Remove enter class so it transitions to normal state
            element.classList.remove(className);
            element.classList.add("engage-active");
        });
    }
    static exit(element, transitionName, speed = "medium", callback) {
        const duration = this.speedMap[speed] || 400;
        const className = this.getOutputClass(transitionName);
        element.style.transition =
            `transform ${duration}ms ease, opacity ${duration}ms ease`;
        if (!className) {
            element.remove();
            callback === null || callback === void 0 ? void 0 : callback();
            return;
        }
        element.classList.remove("engage-active");
        element.classList.add(className);
        setTimeout(() => {
            callback === null || callback === void 0 ? void 0 : callback();
        }, duration);
    }
    static getInputClass(name) {
        switch (name) {
            case "leftToRight":
                return "engage-enter-left";
            case "rightToLeft":
                return "engage-enter-right";
            case "topToBottom":
                return "engage-enter-top";
            case "bottomToTop":
                return "engage-enter-bottom";
            default:
                return null;
        }
    }
    static getOutputClass(name) {
        switch (name) {
            case "leftToRight":
                return "engage-exit-right";
            case "rightToLeft":
                return "engage-exit-left";
            case "topToBottom":
                return "engage-exit-bottom";
            case "bottomToTop":
                return "engage-exit-top";
            default:
                return null;
        }
    }
}
TransitionManager.speedMap = {
    slow: 600,
    medium: 400,
    fast: 200
};
